import React from 'react';
import moment from 'moment';
import Icon from '../../../../../components/Icons';
import { useGlobal } from '../../../../../contexts/Global/context';
import { gerarPdfAgendamento } from '../../../../../services';
import * as S from './styles';
import { downloadFile } from '../../../../../utils';

import Modal from '../../../../../components/Modal';
import PageLoader from '../../../../../components/PageLoader';

const ScheduleItem = ({ item, carteirinha }) => {
    const warningModalInitialData = {
        title: '',
        subtitle: '',
        visible: false,
    };

    const [loading, setLoading] = React.useState(false);
    const { contrastTheme } = useGlobal();
    const [activated, setActivated] = React.useState(false);
    const [showInfo, setShowInfo] = React.useState(false);
    // eslint-disable-next-line no-unused-vars
    const [dataWarningModal, setDataWarningModal] = React.useState(warningModalInitialData);

    const [data, setData] = React.useState({
        data: '',
        horario: '',
        medico: '',
        prestador: '',
        especialidade: '',
        idConsulta: '',
        sequenciaConsulta: '',
        endereco_logradouro: '',
        endereco_numero: '',
        endereco_cep: '',
        endereco_bairro: '',
        endereco_complemento: '',
        endereco_cidade: '',
        endereco_estado: '',
    });

    React.useEffect(() => {
        setData(item);
    }, [item]);

    React.useEffect(() => {}, [data]);

    async function handleDownloadPDF() {
        setLoading(true);
        const payload = {
            cabecalho: {
                canal: 'M',
                codigoEmpresaOrigem: '1',
                divisaoNegocio: '1',
                empresaOrigemAtendimento: '1',
                origemContrato: '1',
                tipoContrato: '1',
                token: '1',
                unidadeNegocio: '1',
            },
            carteirinha,
            codigoEndereco: data.endereco_codigo,
            codigoPrestador: data.prestador_codigo,
            idConsulta: data.idConsulta,
            sequenciaConsulta: data.sequenciaConsulta,
        };

        const response = await gerarPdfAgendamento(payload);

        downloadFile('Agendamento.pdf', `data:text/plain;base64,${response.pdf}`);

        setLoading(false);

        if (response.status !== 200) {
            setDataWarningModal({
                title: 'Arquivo não encontrado',
                subtitle: 'Este arquivo ainda não foi disponibilizado',
                visible: true,
            });
        }
    }

    return (
        <>
            <div>
                <Modal
                    title="Endereço"
                    // subtitle="Rua XYZ"
                    subtitle={`${item.endereco_logradouro} n�mero ${data.endereco_numero},
                ${data.endereco_complemento}
                Bairro ${data.endereco_bairro} - ${data.endereco_cep}
                ${data.endereco_cidade} - ${data.endereco_estado}`}
                    visible={showInfo}
                    onCancel={() => setShowInfo(false)}
                    footer={null}
                    style={{ maxWidth: 500 }}
                >
                    {/* <button type='button' onClick={() => setShowInfo(!showInfo)}>
                          Informa��o
                      </button> */}
                </Modal>
            </div>
            <S.ScheduleItem activated={activated}>
                <S.ScheduleItemContent>
                    <S.ScheduleItemDate>
                        <h1>{moment(data.data, 'DD/MM/YYYY').format('ll')}</h1>
                        <h2>{moment(data.data, 'DD/MM/YYYY').format('dddd')}</h2>
                        <h3>{data.horario}</h3>
                    </S.ScheduleItemDate>
                    <S.ScheduleItemInformation>
                        <div>
                            <h2>{data.prestador}</h2>
                            <button type="button" onClick={() => setShowInfo(!showInfo)}>
                                Informação
                            </button>
                        </div>
                        <div>
                            <h1>Especialidade</h1>
                            <p>{data.especialidade}</p>
                        </div>
                        <div>
                            <h1>Médico</h1>
                            <p>{data.medico}</p>
                        </div>
                    </S.ScheduleItemInformation>
                    <S.ScheduleItemActions>
                        <button type="button" aria-label="pass" onClick={() => setActivated(!activated)}>
                            <Icon name={activated ? 'ArrowUp' : 'ArrowDown'} color="#EC6E0C" />
                        </button>
                    </S.ScheduleItemActions>
                </S.ScheduleItemContent>
                {!!activated && (
                    <S.ScheduleItemFooter>
                        <hr />
                        <ul>
                            <li>
                                <button onClick={handleDownloadPDF} type="button">
                                    <Icon name="CheckCircle" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                                    Gerar PDF
                                </button>
                            </li>
                            <li>
                                <button type="button">
                                    <Icon name="CheckCircle" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                                    Enviar por e-mail
                                </button>
                            </li>
                        </ul>
                    </S.ScheduleItemFooter>
                )}
            </S.ScheduleItem>

            <PageLoader loading={loading} />
        </>
    );
};
export default ScheduleItem;
